export const SUMMARY_CONFIG = {
  mileage: {
    display: '{value}',
    title: 'Mileage',
  },
  exteriorColor: {
    title: 'Ext. Color',
  },
  interiorColor: {
    title: 'Int. Color',
  },
  transmission: {
    display: '{value}',
    title: 'Transmission',
  },
  driveType: {
    display: '{value}',
    title: 'Drive Type',
  },
  fuel: {
    display: '{value}',
    title: 'Fuel',
  },
  enginePower: {
    display: '{value}',
    title: 'Horsepower',
    className: 'text-transform-none',
  },
  mpg: {
    display: '{value}',
    title: 'MPG',
  },
  towingCapacity: {
    display: '{value} lbs',
    title: 'Max Towing Capacity',
    className: 'text-transform-none',
  },
  numberOfSeats: {
    display: '{value}',
    title: 'Seats',
  },
  vin: {
    display: '{value}',
    title: 'VIN',
    className: 'text-transform-none',
  },
};

export const NAVIGATION_IDS = {
  SUMMARY: 'summary',
  HISTORY: 'history',
  FEATURES: 'features',
  SELLER: 'seller',
  REVIEWS: 'reviews',
};

export const NAVIGATION_TITLES = {
  [NAVIGATION_IDS.SUMMARY]: 'Summary',
  [NAVIGATION_IDS.HISTORY]: 'History',
  [NAVIGATION_IDS.FEATURES]: 'Features',
  [NAVIGATION_IDS.SELLER]: 'Seller',
  [NAVIGATION_IDS.REVIEWS]: 'Reviews',
};

export const CONSENT_TEXT = 'By clicking "Finish & Submit", you confirm the information you provided is accurate.';
export const CONSENT_TEXT_MOBILE = 'By submitting, you confirm the information you provided is accurate.';
export const CONSENT_TEXT_STRIPE =
  "By submitting this listing, you confirm the information you provided is accurate. Your listing will not be published until it's reviewed and approved. You won't be charged until your listing goes live.";
export const CONSENT_TEXT_STRIPE_ADHESION =
  'By clicking "Checkout", you confirm the information you provided is accurate.';
export const STRIPE_DETAILS = [{ option: 'Listing Fee' }, { option: 'Listing Duration', value: '90 days' }];
export const CHECKOUT_SUCCESS_DETAILS = [
  { option: 'Payment', value: "You won't be charged until your listing is active." },
  { option: 'Processing Time', value: 'Expect 1–2 business days to go live.' },
  { option: 'Notifications', value: "We'll email you when your listing is published." },
];
export const CHECKOUT_CTA = 'Checkout';
export const STATUS_SUCCESS = 'success';
export const CHECKOUT_VALUE = '$19.99';
export const EXPERIMENT_ID = 'default';

export const PHOTO_ROW_THRESHOLD = 4;

export const SUBMIT_CTA = 'Finish & Submit';
export const NO_UPDATES_MSG = "You haven't made any changes to your listing.";
export const GO_BACK_CTA = 'Go Back';
export const TRY_AGAIN_CTA = 'Try Again';

export const UNAUTHORIZED_ERROR_PATTERN = /401|unauthorized/i;
export const LISTING_ALREADY_EXISTS_ERROR_PATTERN = /409.*already exists/i;
